import * as React from 'react';
import { useAccountOrderPOpbLmlDescription } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountOrderPOpbLmlDescription = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountOrderPOpbLmlDescription();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
